export class TelnyxPhoneNumberApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyPhoneNumbers() {
    return this.#http.get('/api/telnyx/phone-numbers');
  }

  async searchAvailableNumbers(params) {
    return this.#http.get('/api/telnyx/phone-numbers/search', { params });
  }

  async orderPhoneNumbers(body) {
    return this.#http.post('/api/telnyx/phone-numbers/order', body);
  }

  async getOrderStatus(orderId) {
    return this.#http.get(`/api/telnyx/phone-numbers/orders/${orderId}`);
  }

  async assignPhoneNumber({ phoneNumber, userId }) {
    const encodedNumber = encodeURIComponent(phoneNumber);

    return this.#http.patch(`/api/telnyx/phone-numbers/${encodedNumber}/assign`, { userId });
  }

  async deletePhoneNumber(phoneNumber) {
    return this.#http.delete(`/api/telnyx/phone-numbers/${encodeURIComponent(phoneNumber)}`);
  }

  async routeToTexmlApplication({ texmlApplicationId, phoneNumber }) {
    return this.#http.post(
      `/api/telnyx/texml-applications/${texmlApplicationId}/route-phone-number`,
      { phoneNumber },
    );
  }

  async routeToUser({ phoneNumber }) {
    return this.#http.post('/api/telnyx/texml-applications/route-phone-number-to-user', {
      phoneNumber,
    });
  }
}
